// KTCL ITMS test ids
export const ITMS = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  // Layout
  sidebar: "app-sidebar",
  sidebarToggle: "sidebar-toggle",
  navDashboard: "nav-dashboard",
  navSchedule: "nav-schedule-designer",
  navDispatch: "nav-dispatch-board",
  navFleet: "nav-fleet-inventory",
  navOperators: "nav-private-operators",
  navReports: "nav-reports",
  navAdmin: "nav-admin-settings",
  logout: "logout-button",
  // Dashboard
  kpiTotalFleet: "kpi-total-fleet",
  kpiActive: "kpi-active",
  kpiOnTrip: "kpi-on-trip",
  kpiAvailable: "kpi-available",
  kpiMaintenance: "kpi-maintenance",
  kpiBreakdown: "kpi-breakdown",
  kpiCharging: "kpi-charging",
  kpiPrivate: "kpi-private",
  // Dispatch
  dispatchMap: "dispatch-map",
  dispatchKanban: "dispatch-kanban",
  // Schedule
  scheduleGrid: "schedule-grid",
  routesLibrary: "routes-library",
  publishWeek: "publish-week-button",
  // Fleet
  fleetTable: "fleet-table",
  // Operators
  operatorsTabs: "operators-tabs",
  generateInvoice: "generate-invoice-button",
  // Reports
  reportsRoot: "reports-root",
  gtfsCard: "gtfs-card",
  gtfsDownloadBtn: "gtfs-download-button",
  gtfsCopyUrlBtn: "gtfs-copy-url-button",
  gtfsPreviewBtn: "gtfs-preview-button",
  // Admin
  adminTabs: "admin-tabs",
  addUserButton: "add-user-button",
};
